import store from '../store'
export function setSecondRouteList(routeName) {
  const routers = store.getters.router
  const allRouter = store.state.router.allRouters
  const currentRoute = allRouter.find(item => item.routeName === routeName)
  const routeArr = [] // 最子级在最前面
  if (currentRoute) {
    getMenuList(allRouter, currentRoute, routeArr)
  }
  const menuRoute = routers.find(item => item.id === routeArr[routeArr.length - 1]) // 拿最后一个元素，也就是根元素
  // let menu = []
  // if (menuRoute && menuRoute.children) {
  //   const selectMenu = menuRoute.children.find(item => item.id === routeArr[routeArr.length - 2])
  //   if (selectMenu) {
  //     menu = [selectMenu]
  //     console.log(menuRoute.path, menu)
  //   }
  // }
  // const base = allRouter.find(item => item.id === menu[0].parentId)
  store.dispatch('router/setBasePath', menuRoute ? (menuRoute.path || '') : '')
  store.dispatch('router/setShowRouter', menuRoute ? (menuRoute.children || []) : [])
  return currentRoute // 返回当前路由
}
function getMenuList(allRouter, currentRoute, routeArr) {
  if (currentRoute) {
    routeArr.push(currentRoute.id)
  }
  if (currentRoute.parentId !== '' && currentRoute.parentId !== null && currentRoute.parentId !== 0) {
    const parentRoute = allRouter.find(item => item.id === currentRoute.parentId)
    if (parentRoute) {
      getMenuList(allRouter, parentRoute, routeArr)
    }
  }
}
export function getLastRouter(router) {
  while (router.children && router.children.length > 0) {
    for (let i = 0; i < router.children.length; i++) {
      if (router.children[i].type !== 3) {
        router = router.children[i]
        break
      }
    }
  }
  return router
}
